<div class='users-component' style='height: 100%'>
  <mat-tab-group [(selectedIndex)]="selectedIndex">
    <mat-tab label="Active">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">


        <div style="display: flex; flex-direction: row; margin-top: 16px;">
          <form class="example-form">
            <button mat-raised-button
                    (click)="editUser(null)"
                    style="border-radius: 6px; margin-right: 10px;">
              Add User
            </button>
          </form>
        </div>
      </div>
      <p-table [value]="users"
               [rows]="100"
               [paginator]="true"
               [style]="{'margin-top':'10px'}"
               #table
               dataKey="roleGroup"
               (onSort)="updateRowGroupMetaData()" [expandedRowKeys]="expanded"
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of cols">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item.roleGroup].index === rowIndex">
            <td colspan="6">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{roleGroups[item.roleGroup]}}</span>
              </a>
            </td>
          </tr>
        </ng-template>


        <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td *ngFor="let col of cols" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{item[col.field]}}</span>
              <span *ngSwitchCase="'role'">{{getRole(item.role)}}</span>
            </td>
            <td>
              <button type="button"
                      *ngIf="(item.role != 2048 && item.role != 4096 || currentUser.role == 2048 || currentUser.role == 4096 || currentUser.role == 65536)"
                      pButton
                      class="risksponge-button"
                      (click)="editUser(item.userId)"
                      title="Edit user"
                      icon="pi pi-pencil">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="generatePassword(item.userId)"
                      title="Generate new password"
                      icon="pi pi-sort-alt">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="setUserDisabled(item.userId, true)"
                      *ngIf="!item.disabled"
                      title="Disable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button gray"
                      (click)="setUserDisabled(item.userId, false)"
                      *ngIf="item.disabled"
                      title="Enable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="isDeletable(item)"
                      title="Delete user"
                      icon="pi pi-trash"
                      mwlConfirmationPopover
                      [title]="'Delete User'" [popoverMessage]="'You will need to assign a new user to a departing user’s control, evidence and workstream tasks.  Are you sure you wish to delete this user?'"
                      [appendToBody]="true"
                      [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="deleteUser(item.userId)">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="item.isLocked"
                      title="Unlock User"
                      icon="pi pi-lock"
                      (click)="unlockUser(item.userId)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </mat-tab>
    <mat-tab label="Survey">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">


        <div style="display: flex; flex-direction: row; margin-top: 16px;">
          <form class="example-form">
            <button mat-raised-button
                    (click)="editUser(null)"
                    style="border-radius: 6px; margin-right: 10px;">
              Add User
            </button>
          </form>
          <form class="example-form">
            <button mat-raised-button
                    [routerLink]="['/inviteSurvey']"
                    style="border-radius: 6px; margin-right: 10px;">
              Bulk Registration
            </button>
          </form>
        </div>
      </div>

      <p-table [value]="surveyUsers"
               [rows]="100"
               [paginator]="true"
               [style]="{'margin-top':'10px'}"
               #table
               dataKey="roleGroup"

               (onSort)="updateRowGroupMetaData()" [expandedRowKeys]="expanded"
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of cols">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td *ngFor="let col of cols" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{item[col.field]}}</span>
              <span *ngSwitchCase="'role'">{{getRole(item.role)}}</span>
            </td>
            <td>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="editUser(item.userId)"
                      title="Edit user"
                      icon="pi pi-pencil">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="generatePassword(item.userId)"
                      title="Generate new password"
                      icon="pi pi-sort-alt">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="setUserDisabled(item.userId, true)"
                      *ngIf="!item.disabled"
                      title="Disable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button gray"
                      (click)="setUserDisabled(item.userId, false)"
                      *ngIf="item.disabled"
                      title="Enable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="isDeletable(item)"
                      title="Delete user"
                      icon="pi pi-trash"
                      mwlConfirmationPopover
                      [title]="'Delete User'" [popoverMessage]="'You will need to assign a new user to a departing user’s control, evidence and workstream tasks.  Are you sure you wish to delete this user?'"
                      [appendToBody]="true"
                      [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="deleteUser(item.userId)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </mat-tab>
    <mat-tab label="Awareness">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">


        <div style="display: flex; flex-direction: row; margin-top: 16px;">
          <form class="example-form">
            <button mat-raised-button
                    (click)="editUser(null)"
                    style="border-radius: 6px; margin-right: 10px;">
              Add User
            </button>
          </form>
          <form class="example-form">
            <button mat-raised-button
                    [routerLink]="['/invite']"
                    style="border-radius: 6px; margin-right: 10px;">
              Bulk Registration
            </button>
          </form>
        </div>
      </div>
      <p-table [value]="awarenessUsers"
               [rows]="100"
               [paginator]="true"
               [style]="{'margin-top':'10px'}"
               #table
               dataKey="roleGroup"
               (onSort)="updateRowGroupMetaData()" [expandedRowKeys]="expanded"
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of cols">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>


        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td *ngFor="let col of cols" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{item[col.field]}}</span>
              <span *ngSwitchCase="'role'">{{getRole(item.role)}}</span>
            </td>
            <td>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="editUser(item.userId)"
                      title="Edit user"
                      icon="pi pi-pencil">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="generatePassword(item.userId)"
                      title="Generate new password"
                      icon="pi pi-sort-alt">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="setUserDisabled(item.userId, true)"
                      *ngIf="!item.disabled"
                      title="Disable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button gray"
                      (click)="setUserDisabled(item.userId, false)"
                      *ngIf="item.disabled"
                      title="Enable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="isDeletable(item)"
                      title="Delete user"
                      icon="pi pi-trash"
                      mwlConfirmationPopover
                      [title]="'Delete User'" [popoverMessage]="'You will need to assign a new user to a departing user’s control, evidence and workstream tasks.  Are you sure you wish to delete this user?'"
                      [appendToBody]="true"
                      [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="deleteUser(item.userId)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </mat-tab>
    <mat-tab label="Vendor">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">


        <div style="display: flex; flex-direction: row; margin-top: 16px;">
          <form class="example-form">
            <button mat-raised-button
                    (click)="editUser(null)"
                    style="border-radius: 6px; margin-right: 10px;">
              Add User
            </button>
          </form>
        </div>
      </div>
      <p-table [value]="vendorUsers"
               [rows]="100"
               [paginator]="true"
               [style]="{'margin-top':'10px'}"
               #table
               dataKey="roleGroup"
               (onSort)="updateRowGroupMetaData()" [expandedRowKeys]="expanded"
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of cols">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>


        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td *ngFor="let col of cols" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{item[col.field]}}</span>
              <span *ngSwitchCase="'role'">{{getRole(item.role)}}</span>
            </td>
            <td>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="editUser(item.userId)"
                      title="Edit user"
                      icon="pi pi-pencil">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="generatePassword(item.userId)"
                      title="Generate new password"
                      icon="pi pi-sort-alt">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="setUserDisabled(item.userId, true)"
                      *ngIf="!item.disabled"
                      title="Disable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button gray"
                      (click)="setUserDisabled(item.userId, false)"
                      *ngIf="item.disabled"
                      title="Enable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="isDeletable(item)"
                      title="Delete user"
                      icon="pi pi-trash"
                      mwlConfirmationPopover
                      [title]="'Delete User'" [popoverMessage]="'You will need to assign a new user to a departing user’s control, evidence and workstream tasks.  Are you sure you wish to delete this user?'"
                      [appendToBody]="true"
                      [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="deleteUser(item.userId)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </mat-tab>
    <mat-tab label="Inactive">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">


        <div style="display: flex; flex-direction: row; margin-top: 16px;">
          <form class="example-form">
            <button mat-raised-button
                    (click)="editUser(null)"
                    style="border-radius: 6px; margin-right: 10px;">
              Add User
            </button>
          </form>
        </div>
      </div>
      <p-table [value]="inactiveUsers"
               [rows]="100"
               [paginator]="true"
               [style]="{'margin-top':'10px'}"
               #table
               dataKey="roleGroup"
               (onSort)="updateRowGroupMetaData()" [expandedRowKeys]="expanded"
      >
        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of inactiveCols">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header" *ngIf="inactiveRowGroupMetadata[item.roleGroup].index === rowIndex">
            <td colspan="6">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{roleGroups[item.roleGroup]}}</span>
              </a>
            </td>
          </tr>
        </ng-template>


        <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td *ngFor="let col of inactiveCols" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{item[col.field]}}</span>
              <span *ngSwitchCase="'role'">{{getRole(item.role)}}</span>
              <span *ngSwitchCase="'lastLoginTime'">{{formatDateTime(item.lastLoginTime)}}</span>
            </td>
            <td>
              <button type="button"
                      *ngIf="(item.role != 2048 && item.role != 4096 || currentUser.role == 2048 || currentUser.role == 4096)"
                      pButton
                      class="risksponge-button"
                      (click)="editUser(item.userId)"
                      title="Edit user"
                      icon="pi pi-pencil">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="generatePassword(item.userId)"
                      title="Generate new password"
                      icon="pi pi-sort-alt">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="setUserDisabled(item.userId, true)"
                      *ngIf="!item.disabled"
                      title="Disable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button gray"
                      (click)="setUserDisabled(item.userId, false)"
                      *ngIf="item.disabled"
                      title="Enable user"
                      icon="pi pi-power-off">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      *ngIf="isDeletable(item)"
                      title="Delete user"
                      icon="pi pi-trash"
                      mwlConfirmationPopover
                      [title]="'Delete User'" [popoverMessage]="'You will need to assign a new user to a departing user’s control, evidence and workstream tasks.  Are you sure you wish to delete this user?'"
                      [appendToBody]="true"
                      [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="deleteUser(item.userId)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="msg" role="alert" class="alert alert-info alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span>
    </button>
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    <span class="sr-only">Error:</span>
    {{msg}}
  </div>
</div>
